import React from 'react';
import { useRoutes, Navigate } from 'react-router-dom';

// Pages & Components
import ChatPage from './../pages/ChatPage';
import ChatWindow from './../components/ChatWindow';
import WelcomeScreen from './../components/WelcomeScreen';
import Login from './../pages/Login'; 
import BroadCastManager from './../pages/BroadCastManager'; 
import WebLoginPage from './../pages/WebLoginPage'; 
import ProtectedRoute from './ProtectedRoute'; 
import MainLayout from '../components/MainLayout';
import MessageHistory from '../pages/MessageHistory';
import CampaignList from '../pages/CampaignList';
import MessageTemplate from '../pages/MessageTemplate';
import WhatsappTemplate from '../pages/WhatsappTemplate';
import Setting from '../pages/Setting';


const AppRoutes = () => {
  let routes = useRoutes([
    {
      element: <ProtectedRoute publicPage={true} />, 
      children: [{ path: "/login", element: <Login /> }]
    },
    {
      element: <ProtectedRoute />, 
      children: [
        {
          element: <MainLayout />, 
          children: [
            { path: "/", element: <ChatPage />, children: [
                { index: true, element: <WelcomeScreen /> },
                { path: "chat/:id", element: <ChatWindow /> },
            ]},
            { path: "/broadcast", element: <BroadCastManager /> },
            { path: "/message-history", element: <MessageHistory /> }, 
            { path: "/message-history/:campaign_id", element: <MessageHistory /> }, 
            { path: "/campaign-list", element: <CampaignList /> }, 
            { path: "/message-template", element: <MessageTemplate /> }, 
            { path: "/whatsapp-template", element: <WhatsappTemplate /> }, 
            { path: "/settings", element: <Setting /> }, 
            { path: "/web-login", element: <WebLoginPage /> }, 
          ],
        },
      ],
    },
    { path: "*", element: <Navigate to="/login" replace /> }
  ]);
  return routes;
};
export default AppRoutes;